import { classNames } from 'libs/react';
import { Content } from 'components/Content';
import { Error } from 'components/Error';
import { Case } from 'components/util/Case';
import { Else } from 'components/util/Else';
import { When } from 'components/util/When';
import { Waiter } from 'components/Waiter';
import { React } from 'libs/react';
import './Screen.scss';
import { useAccount } from './account/AccountProvider';
import { useDomain } from './domain/DomainProvider';
/**
 * @component Screen
 * @since 1.0.0
 */
export function Screen(props) {
    var _a, _b;
    let { containerStyle, style, name, type, ready, error, minimumLoadingTime, maximumLoadingTime } = Object.assign({ style: 'normal', ready: true, minimumLoadingTime: 0, maximumLoadingTime: 5000 }, props);
    const account = useAccount();
    const domain = useDomain();
    if ((_a = account.options) === null || _a === void 0 ? void 0 : _a.color) {
        document.documentElement.style.setProperty('--primary', account.options.color.includes('#')
            ? account.options.color
            : `#${account.options.color}`);
    }
    else if ((_b = domain.options) === null || _b === void 0 ? void 0 : _b.color) {
        document.documentElement.style.setProperty('--primary', domain.options.color.includes('#')
            ? domain.options.color
            : `#${domain.options.color}`);
    }
    if (name)
        name = name + '-screen';
    if (type)
        type = type + '-screen';
    const className = classNames('screen', 'screen--' + style, { 'screen--is-ready': ready }, { 'screen--is-error': error }, { 'screen--has-name': name }, { 'screen--has-type': type }, props.className, name, type);
    return (React.createElement("div", { className: className, style: containerStyle },
        React.createElement(Waiter, { until: ready, renderWhileLoading: false, minimumLoadingTime: minimumLoadingTime, maximumLoadingTime: maximumLoadingTime },
            React.createElement(When, null,
                React.createElement(Case, { is: error },
                    React.createElement(Content, null,
                        React.createElement(Error, { title: "Ooops!", infos: t('An error occured while trying to perform an action.'), picto: "fal bug", error: error }))),
                React.createElement(Else, null, props.children)))));
}
